import { combineReducers } from 'redux';

import authentication from './authentication.reducer';
import cart from './cart.reducer';
import directSaleCart from './directSaleCart.reducer';
import shopMode from './shopMode.reducer';

export const rootReducer = combineReducers({ authentication, cart, directSaleCart, shopMode });
